import { snakeToCamel } from '../CaseUtils';

export const OrderHistoryETL = (history) => history?.map(snakeToCamel);
export const DriverHistoryETL = (history) => history?.map(snakeToCamel);

export const DriverEarningsETL = (response) => {
  const amount = response?.total_earned?.total;
  const count = response?.total_results;
  const numeric = (value) =>
    (typeof value === 'number' ||
      (typeof value === 'string' && value.trim() !== '')) &&
    Number.isFinite(Number(value));
  if (!numeric(amount) || !numeric(count) ||
      !Number.isInteger(Number(count)) || Number(count) < 0) {
    throw new Error('Invalid driver earnings history totals');
  }
  return { earned: Number(amount), completed: Number(count) };
};
